import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Input.scss';

var Unit = function Unit(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return React.createElement(
    'div',
    {
      className: styles.unit,
      'data-hook': 'unit'
    },
    value || children
  );
};

Unit.displayName = 'Input.Unit';
Unit.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string
};

export default Unit;
//# sourceMappingURL=Unit.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/Unit/Unit.js